import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M11.9401 3.20195C11.0211 4.04595 10.0343 4.67095 8.9236 5.11495C7.81188 5.56095 6.60169 5.81195 5.22421 5.88395C4.70435 5.91195 4.29142 6.31695 4.28401 6.80595C4.28295 6.88395 4.28083 6.95995 4.27872 7.03295L4.26389 7.45595L4.24907 8.31495C4.21731 10.459 4.27448 12.798 5.11515 14.952C6.20358 17.745 8.43127 19.661 11.9221 20.811L11.9613 20.821C11.9983 20.827 12.0354 20.827 12.0714 20.821C12.0841 20.818 12.0989 20.815 12.1105 20.811L12.479 20.684C15.7559 19.52 17.8629 17.641 18.9143 14.949C19.7571 12.791 19.8153 10.4489 19.7846 8.30295L19.7698 7.45595C19.7655 7.38795 19.7624 7.31995 19.7603 7.24995L19.7497 6.80595C19.7423 6.31695 19.3283 5.91195 18.8095 5.88395C17.4309 5.81195 16.2207 5.56095 15.109 5.11495C13.9984 4.67095 13.0116 4.04595 12.0936 3.20195C12.0703 3.18295 12.0438 3.17395 12.0163 3.17395C11.9898 3.17395 11.9634 3.18295 11.9401 3.20195Z',
                    fill: '#30CD60',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M15.3705 9.20702L11.0465 13.291L9.15019 11.499C8.8569 11.222 8.38257 11.222 8.08929 11.499C7.79706 11.775 7.79706 12.223 8.08929 12.5L10.5181 14.792C10.8093 15.068 11.2836 15.068 11.5769 14.792L16.4314 10.208C16.7237 9.93102 16.7237 9.48302 16.4314 9.20702C16.2853 9.06802 16.0926 8.99902 15.901 8.99902C15.7094 8.99902 15.5177 9.06802 15.3705 9.20702Z',
                    fill: 'white',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const GuaranteeCheckedColored = React.forwardRef(IconComponent);
GuaranteeCheckedColored.displayName = 'GuaranteeCheckedColored';

export { GuaranteeCheckedColored };
